import React, { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import trans, { isRTL } from "../../../utils";
import {
	AltitudeUnit,
	DistanceUnit,
	SpeedUnit,
} from "../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function PlayBackParameters({ parameters }) {
	let { posIndex } = useContext(popupcontext);
	const inf = useSelector((state) => state.users.user);
	function knotsToKmPerHour(knots) {
		return knots * 1.852;
	}
	function convertMillisecondsToTime(ms) {
		const totalMinutes = Math.floor(ms / 60000); // Convert ms to minutes
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		if (isRTL) {
			return `منذ ${hours}س${minutes}د `;
		} else {
			return `${hours}h${minutes}m`;
		}
	}
	return (
		<div className="history-playback-parameter">
			<div className="history-playback-parameter-head">
				<div>{trans("Parameters")}</div>
			</div>
			<div className="history-playback-parameter-body">
				<div className="history-playback-parameter-values">
					<div className="history-playback-parameter-key">
						{trans("protocol")} :
					</div>
					<div className="history-playback-parameter-value">
						{parameters[posIndex].protocol}
					</div>
				</div>
				<div className="history-playback-parameter-values">
					<div className="history-playback-parameter-key">
						{trans("Speed")} :
					</div>
					<div className="history-playback-parameter-value">
						{SpeedUnit(
							parameters[posIndex].speed,
							inf?.attributes?.speedUnit || "kn"
						)}
					</div>
				</div>
				<div className="history-playback-parameter-values">
					<div className="history-playback-parameter-key">
						{trans("altitude")} :
					</div>
					<div className="history-playback-parameter-value">
						{AltitudeUnit(
							parameters[posIndex].altitude,
							inf?.attributes?.altitudeUnit || "m"
						)}
					</div>
				</div>
				<div className="history-playback-parameter-values">
					<div className="history-playback-parameter-key">
						{trans("course")} :
					</div>
					<div className="history-playback-parameter-value">
						{parameters[posIndex].course}
					</div>
				</div>
				{Object.entries(parameters[posIndex].attributes).map(([key, value]) => {
					let formattedValue;

					if (
						[
							"odometer",
							"totalodometer",
							"distance",
							"totalDistance",
						]?.includes(key)
					) {
						formattedValue = DistanceUnit(
							value,
							inf?.attributes?.distanceUnit || "km"
						);
					} else if (key === "hours") {
						formattedValue = convertMillisecondsToTime(value);
					} else if (typeof value === "boolean") {
						formattedValue = value ? "ON" : "OFF";
					} else {
						formattedValue = Math.round(value * 10) / 10;
					}

					return (
						<div key={key} className="history-playback-parameter-values">
							<div className="history-playback-parameter-key">
								{trans(key)} :
							</div>
							<div className="history-playback-parameter-value">
								{formattedValue}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
